/**
 * request.js
 * 通过promise对axios做二次封装，针对用户端参数，做灵活配置
 */
import { Message,Loading } from 'element-ui';
import service from './request'
import router from '../router'
import qs from 'qs'
/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 * @param mock 本次是否请求mock而非线上
 * @param error 本次是否显示错误
 */
function request(url,params,options,method){
    let loadingInstance;
    // 请求前loading
    if(options.loading){loadingInstance=Loading.service();}
    // return new Promise((resolve,reject)=>{
		
        let fn = null
        if(method =='get'){
            fn = service.get(options.api+url,{params:params})
        }else{
            fn = service.post(options.api+url, params)
        }
        // 通过mock平台可对局部接口进行mock设置
        return fn.then((res)=>{
            // 此处作用很大，可以扩展很多功能。
            // 比如对接多个后台，数据结构不一致，可做接口适配器
            // 也可对返回日期/金额/数字等统一做集中处理
            if(res.code == 200){
                return res;
            }else if(res.code==401){
                Message.error('请登录');
                localStorage.removeItem('token');
                localStorage.removeItem('userinfo');
                router.push({path: '/login'});
            }else if(res.code==500){
                if(res.msg)Message.error(res.msg);
                return res;
            }else{
                // 通过配置可关闭错误提示
                if(options.error)Message.error(res.msg);
                return res;
            }
        }).catch((error)=>{
            // console.log(error)
            // Message.error(error.message)
        }).finally(()=>{
            if(loadingInstance){
                loadingInstance.close();
            }
        })
    // })
}
// 封装GET请求
function get(url,params,options={loading:true,error:true,api:'/api'}){
    // console.log(url)
    // console.log(params)
    return request(url,params,options,'get')
}
// 封装POST请求
function post(url,params,options={loading:true,error:true,api:'/api'}){
    return request(url,params,options,'post')
}
export default {
    get,post
}

